import { ChangeEvent, useCallback, useState } from 'react';
import { ModelState } from './ModelState';
import { useGraphQL } from './useGraphQL';
import { TestingClient } from '../GraphQL.Testing';
import { ValidationMessage } from './ValidationMessage';
import { useLayoutContext } from '../layout/Layout';

interface CaptchaProps {
    modelState?: ModelState | undefined;
    onChange: (code: string) => void;
    value?: string;
}

export function Captcha(props: CaptchaProps) {
    const { onChange } = props;

    const { model: { isProduction } } = useLayoutContext();
    const [rand, setRand] = useState(Math.random());

    const handleGenerateNewImageClick = useCallback(() => setRand(Math.random()), []);
    const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => onChange?.(e.currentTarget.value), [onChange]);
    const client = useGraphQL(TestingClient);
    const handleLoad = useCallback(async () => {
        if (isProduction) return;
        const result = await client.getSession();
        const code = result.data?.session?.find((x) => x?.key === 'CaptchaCode')?.value;
        onChange?.(code ?? '');
    }, [client, onChange, isProduction]);
    return (
        <div className="row mb-3">
            <div className="form-group col-8 col-md-6 flex-grow md:flex-grow-0">
                <div className="form-control form-control-lg captcha-box" style={{ background: 'url(/Utilities/CaptchaNoise.jpg)' }}>
                    <img src={`/Utilities/Captcha.jpg?${rand}`} className="captcha" alt="CAPTCHA" onLoad={handleLoad} />
                </div>
                <button
                    title="Generate New Image"
                    className="btn btn-link small-text text-muted"
                    type="button"
                    onClick={handleGenerateNewImageClick}
                >
                    Generate New Image
                </button>
            </div>

            <div className="form-group col-8 col-md-6 flex-grow md:flex-grow-0">
                <label className="sr-only" htmlFor="captchaCustomerInput">
                    Customer Input
                </label>
                <input
                    type="tel"
                    value={props.value ?? ''}
                    className="form-control form-control-lg account-number"
                    id="capthaCustomerInput"
                    onChange={handleChange}
                />
                <ValidationMessage modelState={props.modelState} name="captcha" />
            </div>
        </div>
    );
}
